import React, { useCallback } from 'react';
import { Button } from '@televet/kibble-ui';
import { useRetryCampaignRegistrationMutation, TwilioA2PRegistrationStatusDocument } from 'shared/types/graphql';
import useClinicUser from 'shared/hooks/useClinicUser';
import { useToast } from '@televet/kibble-ui/build/components/Toast';

export const RetryCampaignButton = (): JSX.Element => {
  const { currentClinicId } = useClinicUser();
  const [retryCampaignRegistration, { loading: isLoadingTwilioCampaignRegistrationRetry }] =
    useRetryCampaignRegistrationMutation();
  const toast = useToast();

  const onRetryCampaignRegistrationButtonClicked = useCallback(async () => {
    if (!currentClinicId) {
      toast({
        title: 'No Clinic Id Provided!',
        description: 'Cannot retry campaign registration without clinicId. Try reloading the page and trying again.',
        status: 'error',
      });
      return;
    }
    try {
      const result = await retryCampaignRegistration({
        variables: {
          clinicId: currentClinicId,
        },
        refetchQueries: [TwilioA2PRegistrationStatusDocument],
      });
      if (result) {
        toast({
          title: 'Successfully Created Campaign! Refresh to see status updates.',
          status: 'success',
        });
      }
    } catch (error) {
      toast({
        title: 'Error Creating Campaign Registration!',
        description: error.message,
        status: 'error',
      });
    }
  }, [currentClinicId, retryCampaignRegistration, toast]);

  return (
    <Button isLoading={isLoadingTwilioCampaignRegistrationRetry} onClick={onRetryCampaignRegistrationButtonClicked}>
      Retry Campaign Registration
    </Button>
  );
};
